export function getIsPageHostname(url: string) {
  return PAGE_HOST_NAME_REGEX.test(url);
}

const PAGE_HOST_NAME_REGEX = /page\.(devel\.)?kakao\.com/;
